var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5359in",
    height: "1.5362in",
    viewBox: "0 0 39.011 39.019",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m32.584 8.7654 4.3251 1.7581-1.1376 4.5281 3.2361 3.3653-2.881 3.674 1.5875 4.3906-4.1262 2.1845-0.33553 4.6567-4.658 0.31738-2.2006 4.1177-4.3844-1.6046-3.6851 2.8666-3.3527-3.2492-4.5325 1.1199-1.7413-4.3319-4.5962-0.82044 0.17125-4.6657-3.8651-2.6189 2.0541-4.1926-2.4657-3.9646 3.5819-2.9947-0.63997-4.6247 4.4902-1.2789 1.2964-4.4852 4.6222 0.65801 3.0086-3.5701 3.9549 2.4811 4.2006-2.0378 2.6038 3.8753 4.6663-0.15307z",
    style: {
      fill: "#e7a62b",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 0.34315
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(35.459 5.4858 -497.19)",
    d: "m302.66-97.148-0.26756 3.2827-4.147 2.1453 1.546 4.4057-2.9154 3.6466 1.9072 2.0213 36.797-5.1e-5 -2.1433-3.5197 2.0935-4.1734-3.84-2.6552 0.21515-4.664-2.601-0.48979-26.645 5.36e-4z",
    style: {
      fill: "#f1c242",
      stopColor: "#000000"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-287.41 -95.395)"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(287.41,95.395)",
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(35.459 5.4858 -497.19)",
    d: "m299.31-77.341-0.41415 1.5867 4.0408 1.6874 29.849 2e-5 -0.42159-3.2741-33.054 2.5e-5z",
    style: {
      InkscapeStroke: "none",
      fill: "#f1c242",
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-287.41 -95.395)"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(287.41,95.395)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(287.41,95.395)",
    xlinkHref: "#a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.f56bb5d29ca56bf187135083d3c90e1c.svg";
export { ForwardRef as ReactComponent };